import React from 'react';
import { bool, func } from 'prop-types';
import { noop } from 'lodash';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Button as PentaButton } from '@fiverr-private/button';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Button, Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import { getCheckoutCtaCopyKey } from './getCheckoutCtaCopy';

const OpenDrawerButton = ({ onClick = noop, loading = false, isRestrictedByRegion }) => {
    const continueCopyKey = getCheckoutCtaCopyKey();
    const { isInCheetahsMobileGigPage, isInCheetahsGigPageButtonsColors } = useGigPageContext();

    if (isInCheetahsMobileGigPage || isInCheetahsGigPageButtonsColors) {
        return (
            <PentaButton
                type="button"
                onClick={onClick}
                loading={loading}
                disabled={isRestrictedByRegion}
                size={isInCheetahsMobileGigPage ? { default: 'lg', sm: 'md' } : 'md'}
                fullWidth={isInCheetahsMobileGigPage ? { default: true, sm: false } : true}
                variant={isInCheetahsGigPageButtonsColors ? 'outline' : 'filled'}
            >
                <I18n k={continueCopyKey} />
                <ArrowRightIcon color={isInCheetahsGigPageButtonsColors ? 'currentColor' : 'white'} />
            </PentaButton>
        );
    }

    return (
        <Button
            type="button"
            onClick={onClick}
            loading={loading}
            color={Button.COLORS.BLACK}
            disabled={isRestrictedByRegion}
        >
            <I18n k={continueCopyKey} />
            <Icon className="rf" color={Button.COLORS.WHITE}>
                {l_arrow_right}
            </Icon>
        </Button>
    );
};

OpenDrawerButton.propTypes = {
    onClick: func,
    loading: bool,
    isRestrictedByRegion: bool,
};

export default OpenDrawerButton;
